import {useEffect, useState} from "react";
import ApiService from "../../core/service/ApiService";
import {Select} from "antd";
import {t} from "i18next";

export default function CashRegisterSelectList({all, onList, allOption, ...props}) {
    const [cashRegisters, setCashRegisters] = useState([])

    const getCashRegisters = async () => {
        const res = await ApiService.CashRegister.GetCashRegisters(all || false)
        if(res.success) {
            const registers = res.data
            setCashRegisters(registers)
            onList && onList(registers)
        }
    }

    useEffect(() => {
        getCashRegisters()
    }, []);

    return (
        <Select
            {...props}
        >
            {
                allOption && (
                    <Select.Option value={-1}>
                        {t('All')}
                    </Select.Option>
                )
            }
            {
                cashRegisters.map(f => (
                    <Select.Option value={f.id}>
                        {f.name}
                    </Select.Option>
                ))
            }
        </Select>
    )
}